import _extends from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { TextField } from '@material-ui/core';
import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import isString from 'lodash/isString';
import { useCallback, useMemo, useState } from 'react';
import { connectRefinementList } from 'react-instantsearch-core';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDebounce } from 'react-use';
import { TagAutocompleteChip } from 'components/common/TagAutocompleteChip';
import { TagAutocompleteOption } from 'components/common/TagAutocompleteOption';
import { TagAutocomplete } from 'components/common/material-ui/custom-components';
import { SEARCH_DEBOUNCE_MS } from 'config/algolia/ux';
import generateTruncatedSections from 'libs/content/utils/generateTruncatedSections';
import { Container } from './MainSectionFilter.style';

var MainSectionFilter = function MainSectionFilter(_ref) {
  var items = _ref.items,
      fieldLabelIdPrefix = _ref.fieldLabelIdPrefix,
      refine = _ref.refine,
      currentRefinement = _ref.currentRefinement,
      searchForItems = _ref.searchForItems;
  var intl = useIntl();

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var isRefined = useMemo(function () {
    return flatten(currentRefinement).length !== 0;
  }, [currentRefinement]);
  var options = useMemo(function () {
    return compact(items.map(function (_ref2) {
      var label = _ref2.label;
      return label;
    }));
  }, [items]);
  var handleChange = useCallback(function (event, value) {
    refine([value !== null && value !== void 0 ? value : '']);
  }, [refine]);
  useDebounce(function () {
    searchForItems(inputValue);
  }, SEARCH_DEBOUNCE_MS, [inputValue, searchForItems]);
  return __jsx(Container, null, __jsx(TagAutocomplete, {
    defaultValue: currentRefinement,
    multipleTag: false,
    multiple: true,
    options: isRefined ? [] : options,
    noOptionsText: intl.formatMessage({
      id: "tagAutocomplete.noOptionsText.".concat(isRefined ? 'filled' : 'default')
    }),
    onChange: handleChange,
    onInputChange: function onInputChange(event, value) {
      return setInputValue(value);
    },
    renderInput: function renderInput(params) {
      var newParams = isRefined ? _objectSpread(_objectSpread({}, params), {}, {
        inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
          style: {
            display: 'none',
            visibility: 'hidden'
          }
        })
      }) : params;
      return __jsx(TextField, _extends({}, newParams, {
        label: __jsx(FormattedMessage, {
          id: "".concat(fieldLabelIdPrefix, ".label")
        }),
        variant: "outlined"
      }));
    },
    renderOption: function renderOption(label, state) {
      return __jsx(TagAutocompleteOption, {
        label: label,
        state: state,
        isMultiple: false
      });
    },
    renderTags: function renderTags(values, getTagProps) {
      return values.map(function (label, index) {
        // label may be a string[] without failing type verification...
        var labelString = isString(label) ? label : label[0];
        return __jsx(TagAutocompleteChip, {
          key: label,
          label: generateTruncatedSections(labelString),
          title: labelString,
          getTagProps: getTagProps,
          index: index,
          isMultiple: false,
          deleteIcon: false,
          horizontalScroll: true
        });
      });
    } // Setting `filterOptions` as the identity function allows to let algolia do the filtering
    ,
    filterOptions: function filterOptions(algoliaOptions) {
      return algoliaOptions;
    }
  }));
};

export default connectRefinementList(MainSectionFilter);